import Auth from '../Auth'
import {actions,AUTHENTICATION_LOGIN,AUTHENTICATION_SUCCESS,AUTHENTICATION_ERROR,
  AUTHENTICATION_LOGOUT,AUTHENTICATION_CHECK,
    CHECK_SESSION, CHECK_SESSION_SUCCESS, CHECK_SESSION_FAILURE} from './actionsAuth.js'

import * as actionTypes from '../services/auth.js'

// ------------------------------------
// REDUCERS
// ------------------------------------

function check(state, action) {
  let result = state
  const grantedScopes = state.authClient.getGrantedScopes()
  if (state.authClient.isAuthenticated()) {
    result = Object.assign({}, state, {
          isAuthenticated: true,
          isAuthenticating:false,
          authenticationError:false,
          grantedScopes: grantedScopes,
          data: action.payload
    });
  }
  return result

}

function login(state, action) {
  state.authClient.login()
  let result = Object.assign({}, state, {
        isAuthenticating: true
      });
  return result
}

function logout(state, action) {
  state.authClient.logout()
  let result = Object.assign({}, state, {
        isAuthenticating: false,
        isAuthenticated: false,
        authenticationError: false,
        grantedScopes: []
      });
  //result.authClient.logout()
  return result

}

function authenticationSuccess(state, action) {
  let result = state
  try {
    state.authClient.handleAuthentication(action.payload)
  } catch(e) {
     result = Object.assign({}, state, {
          isAuthenticated: false,
          isAuthenticating:false,
          authenticationError:true,
          grantedScopes:[]
      });
  }

  return {
      ...result,
      loadingUserData: true
  } ;
}

function authenticationError(state, action) {
  let result = Object.assign({}, state, {
        authenticationError: true,
        isAuthenticating: false,
        isAuthenticated: false
      });
  return result;
}

// Session previamente guardada

function checkSession(state,action) {
    let checkSession = state.authClient.checkSession();
    return Object.assign({}, state, {
        isAuthenticated: checkSession != null
    });
}

//LISTAR MÉDICO POR EMAIL

// Sets Loading state
function isLoading(state,action) {
  let result = Object.assign({}, state, {
        isLoading: true
      });
  return result;
}

// Excecutes when request Error
function requestError(state,action) {

  let result = Object.assign({}, state, {
        isLoading: false,
        // hasErrored: action.error,
        data:null
      });
  return result;
}

function requestSuccess(state,action) {

  let result = Object.assign({}, state, {
        isLoading: false,
        hasErrored: false,
        data: {
            ...state.data,
            ...action.response,
            avatar: action.response.avatar || state.data.avatar
        },
        isAuthorized: true,
      });
  return result;
}


function updateUserData(state,action) {

  let result = Object.assign({}, state, {
        data:action.payload,
      });
  return result;
}

const ACTION_HANDLERS = {
    [AUTHENTICATION_CHECK] : (state, action) => check(state,action),
    [AUTHENTICATION_SUCCESS] : (state, action) => authenticationSuccess(state,action),
    [AUTHENTICATION_ERROR]: (state, action) => authenticationError(state,action),
    [AUTHENTICATION_LOGIN] : (state, action) => login(state,action),
    [AUTHENTICATION_LOGOUT] : (state, action) => logout(state,action),

    // [actionTypes.SEARCH_MEDICO_EMAIL_API_LOADING] : (state, action) => isLoading(state,action),
    // [actionTypes.SEARCH_MEDICO_EMAIL_API_SUCCESS] : (state, action) => requestSuccess(state,action),
    // [actionTypes.SEARCH_MEDICO_EMAIL_API_ERROR]: (state, action) => requestError(state,action),

    [actionTypes.GET_MEDICO_LOGUEADO_API_REQUEST] : (state, action) => isLoading(state,action),
    [actionTypes.GET_MEDICO_LOGUEADO_API_SUCCESS] : (state, action) => requestSuccess(state,action),
    [actionTypes.GET_MEDICO_LOGUEADO_API_FAILURE]: (state, action) => requestError(state,action),

    [actionTypes.UPDATE_USER_DATA]: (state,action) => updateUserData(state, action),

    [CHECK_SESSION]: (state,action) => checkSession(state,action),
}

// ------------------------------------
// Reducer
// ------------------------------------
const auth = new Auth();
const initialState = {
  authClient: auth,
  usuarioLogueado: {},
  loadingUserData: false,
  isAuthorized: false,
  authenticationError: false,
  isAuthenticating: false,
  isAuthenticated: auth.isAuthenticated(), //Levanto desde localstorage
  grantedScopes: auth.getGrantedScopes(),//Levanto desde localstorage
  data: null,
  hasErrored: false,
  isLoading: false
}

export default function authReducer (state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  const resultState =handler ? handler(state, action) : state
  return resultState
}



// WEBPACK FOOTER //
// ./src/security/modules/auth.js